import { connMTUpdater } from './connMTUpdater.js';
import { autoSyncer } from './autoSyncer.js';
import { CommandRegistry } from './ajaxWrapNew.js';

export function addStatCounter(connectSID, connectIID, iid) {
    const id = 'cnti' + iid;
    const $connMT = $('.' + id);
    const connUpdater = new connMTUpdater({
        selector: '.' + id
    });

    autoSyncer.setGlobal('connectSID', connectSID);
    autoSyncer.setGlobal('connectIID', connectIID);

    CommandRegistry.registerCommand('statCounter', (counterData) => {
        if (counterData.counterTT) {
            connUpdater.updateTitle(counterData.counterTT);
        }
        if (counterData.counter !== undefined) {
            if ($connMT.data('cnt') != counterData.counter) {
                $connMT.data('cnt', counterData.counter);
                connUpdater.update(counterData.connMT, counterData.counter);
            }
        }
    });

    autoSyncer.add('stat-counter', id, {
        counter: $connMT.data('cnt'),
        iid: iid
    }, function (itemData) {
        if (itemData.counter !== undefined) {
            return {
                counter: itemData.counter
            };
        }
        return false;
    });
}